import { CreateCompanyPayload } from 'services/clients/user';

type Field = 'name' | 'scac' | 'other';

export interface CompanyType {
  label: string;
  key: CreateCompanyPayload['company_type_detail'];
  fields: Field[];
}

export const companyTypes: CompanyType[] = [
  { label: 'Drayage Carrier / Trucking', key: 'Drayage Carrier', fields: ['name', 'scac'] },
  { label: 'Owner Operator', key: 'Owner Operator', fields: ['name', 'scac'] },
  { label: 'Broker', key: 'Broker', fields: ['name'] },
  { label: '3PL', key: '3PL', fields: ['name'] },
  { label: 'Warehousing', key: 'Warehousing', fields: ['name'] },
  { label: 'Freight Forwarder', key: 'Freight Forwarder', fields: ['name'] },
  { label: 'BCO / Consignee', key: 'BCO / Consignee', fields: ['name'] },
  { label: 'Other', key: 'Other', fields: ['name', 'other'] },
];
